import angular from 'angular';
import { get } from 'lodash';
import './modals/totems';
import '../services/totem';
import '../services/errors';
import '../services/place';
import '../app.constants';

const module = angular.module('whyline.controllers.totems', [
  'whyline.modals.totems',
  'whyline.services.totem',
  'whyline.services.place',
  'whyline.services.errors',
  'whyline.constants',
]);

const TotemsController = (
  $scope,
  $state,
  $uibModal,
  $translate,
  $timeout,
  $location,
  TotemService,
  PlaceService,
  NotificationService,
  ErrorService,
  dialog,
  currentOrganization,
  URL_NEW_KIOSK,
) => {
  /*@ngInject*/
  const merchantMaxTotems = 1; // TODO: change when plan scope gets implemented

  $scope.title = 'totems';
  $scope.quantityOfItems = 8;
  $scope.organizationId = $state.params.organizationId;
  $scope.totems = TotemService.GetAll();

  PlaceService.GetCurrentAsPromise().then((place) => {
    $timeout(() => {
      $scope.place = place;
    });
  });

  $scope.getTotemUrl = (totem) => {
    $scope.viewEasyTotem = get($scope.place, 'configuration.viewEasyTotem', false);
    const route = `totem${$scope.viewEasyTotem ? '-new' : ''}-tv.welcome`;
    const params = {
      placeId: totem.placeId,
      organizationId: $scope.organizationId,
      totemId: totem._id,
    };
    return $state.href(route, params);
  };

  $scope.plan = {};
  $scope.plan.maxTotems = get(
    currentOrganization,
    'configuration.plan.maxTotems',
    merchantMaxTotems,
  );

  $scope.canCreateTotem = () => {
    const maxTotems = parseInt($scope.plan.maxTotems, 10);
    return Object.keys($scope.totems).length < maxTotems || maxTotems === -1;
  };

  $scope.remove = (totemId, name) => {
    let n = name || '';
    let text = $translate.instant('totem_{name}_remove_sure').replace('{name}', n);
    dialog.confirm(text).then(() => {
      TotemService.Remove(totemId)
        .then(() => {
          let n = name || '';
          let text = $translate.instant('totem_{name}_remove_succ').replace('{name}', n);
          NotificationService.Success(text);
        })
        .catch(ErrorService.handler);
    });
  };

  $scope.switch = TotemService.Switch;

  $scope.refresh = (totemId) => TotemService.Refresh(totemId);

  // Modal
  $scope.open = (totemId) => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/totems-modal.html',
      size: 'lg',
      controller: 'TotemModalController',
      resolve: {
        totemId: () => totemId,
      },
    });
  };

  const getTenantId = () => {
    const url = $location.absUrl();
    const urlParts = url.substring(url.indexOf('://') + 3).split('.');

    return $state.params.tenantId || urlParts[0];
  };

  $scope.redirectToTotemBA = (totemId, withVirtualKeyboard) => {
    TotemService.GetTotemBAHash(totemId)
      .then((hash) => {
        const { origin } = window.location;
        const urlParts = origin.substring(origin.indexOf('://') + 3).split('.');
        const { slug } = currentOrganization;
        let kioskUrl;
        if (urlParts[0] === 'admin' && (urlParts[2] === slug || urlParts[1] === slug)) {
          kioskUrl = origin.replace('admin', 'kiosk');
        } else {
          const tenantId = getTenantId();
          const prefix =
            tenantId !== 'enterprise' && !tenantId.includes('localhost')
              ? `${tenantId}-kiosk`
              : 'kiosk';
          kioskUrl = URL_NEW_KIOSK.replace('kiosk', prefix);
        }
        const fullUrl = withVirtualKeyboard
          ? `${kioskUrl}?virtualine=${hash}&organizationId=${$scope.organizationId}&placeId=${$scope.place._id}&totemId=${totemId}&showVirtualKeyboard=${withVirtualKeyboard}`
          : `${kioskUrl}?virtualine=${hash}&organizationId=${$scope.organizationId}&placeId=${$scope.place._id}&totemId=${totemId}`;
        window.open(fullUrl, '_blank');
      })
      .catch(ErrorService.handler);
  };
};

module.exports = module.controller('TotemsController', TotemsController);
